<h2 *ngIf="layers.length > 0" mat-dialog-title class="font-weight-bolder add-data-title">Add Data</h2>
<mat-dialog-content>
  <mat-label #lblError id="lblError" class="error"></mat-label>
  <div *ngIf="layers.length > 0" class="upload-layer-container" [formGroup]="newLayerForm">
    <div class="wmts-table-header">
      <span class="wmts-th-name">Layer</span>
      <span class="wmts-th-select">Projection</span>
      <span class="wmts-th-select">Format</span>
    </div>
    <div class="upload-layer-content">
      <mat-radio-group formControlName="selectedLayer">
        <div *ngFor="let layer of layers; let i = index" class="wmts-info-row">
          <div class="wmts-name-cell">
            <mat-radio-button [value]="layer" id="{{ layer.Title }}"></mat-radio-button>
            <mat-form-field appearance="outline" class="form-ultra-slim wmts-name-field">
              <input
                matInput
                formControlName="newLayerName-{{ i }}"
                [readonly]="!layer.edit"
                (change)="changeLayerName($event, i)"
                (keyup.enter)="editLayerName(layer)" />
              <button mat-icon-button matSuffix type="button" (click)="editLayerName(layer)">
                <mat-icon>{{ layer.edit ? 'check' : 'edit' }}</mat-icon>
              </button>
            </mat-form-field>
          </div>
          <mat-form-field class="form-ultra-slim wmts-select-field">
            <mat-select id="{{ layer.Title }}Matrix" [(value)]="layer.TileMatrixSetLink[0].TileMatrixSet" required>
              <mat-option *ngFor="let link of layer.TileMatrixSetLink" [value]="link.TileMatrixSet">{{ link.TileMatrixSet }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field class="form-ultra-slim wmts-select-field">
            <mat-select id="{{ layer.Title }}Format" [(value)]="layer.Format[0]" required>
              <mat-option *ngFor="let format of layer.Format" [value]="format">{{ format }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </mat-radio-group>
    </div>
    <div *ngIf="anyChecked()" class="d-flex align-items-center g-1 mt-2">
      <span>Opacity:</span>
      <mat-slider class="flex-grow-1" min="0" max="100" step="1" [displayWith]="formatPercentLabel">
        <input matSliderThumb formControlName="newLayerOpacity">
      </mat-slider>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton="elevated" [mat-dialog-close]="false">Back</button>
  <button matButton="filled" color="primary" color="primary" id="btnAdd" [mat-dialog-close]="true" [disabled]="!anyChecked()" (click)="addWMTSLayers()">
    Add
  </button>
</mat-dialog-actions>
